module.exports = __webpack_public_path__ + "static/img/cards.3dd5409.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards.jpg
// module id = zYjp
// module chunks = 126